export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.$router.options.scrollBehaviorType = 'smooth'
  })